.layout {
  display: grid;
  grid-template-columns: var(--sidebar-w) 1fr;
  min-height: 100vh;
}

.sidebar {
  min-width: 0;
  background: var(--surface);
  border-right: 1px solid var(--border);
  padding: 24px 16px;
}

.logo {
  display: block;
  width: 120px;
  height: auto;
  margin: 0 8px 24px;
}

.nav {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.link {
  border-radius: var(--radius-sm);
  color: var(--text-secondary);
  padding: 10px 12px;
  text-decoration: none;
  min-height: 40px;
}

.link:hover {
  background: var(--surface-soft);
  color: var(--text);
}

.active {
  background: var(--accent-soft);
  color: var(--accent-strong);
  font-weight: 500;
}

.main {
  padding: 32px;
  max-width: 1200px;
}

@media (max-width: 767px) {
  .layout {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto 1fr;
  }

  .sidebar {
    border-right: none;
    border-bottom: 1px solid var(--border);
    padding: 12px 16px;
  }

  .nav {
    flex-direction: row;
    overflow-x: auto;
  }

  .main {
    padding: 20px 16px;
  }
}
